/* unplugin-vue-components disabled */import script from "./PostDraftItemBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDraftItemBox.vue?vue&type=script&setup=true&lang=ts"

import "./PostDraftItemBox.vue?vue&type=style&index=0&id=25849027&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25849027"]])

export default __exports__